<template>
  <div v-if="!loader" class="pa-4 mt-n6">
    <v-row class="mt-n16 px-6  align-center">
      <v-icon color="#007bff" size="60">mdi-notebook</v-icon>
      <h2 class="primary--text">
        {{ data.name }}
      </h2>
    </v-row>
    <v-row>
      <v-breadcrumbs :items="breadcrumbsItems">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item :href="item.href">
            <span
              @click="move(item)"
              :class="{
                'primary--text':
                  item !== breadcrumbsItems[breadcrumbsItems.length - 1],
                disable: item === breadcrumbsItems[breadcrumbsItems.length - 1],
              }"
            >
              {{ item.text }}</span
            >
          </v-breadcrumbs-item>
        </template>
        <template #divider>
          <v-icon color="#007bff">mdi-arrow-left</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>
    <component
      @openUnit="nextStep($event, 'lessons')"
      @openLesson="$router.push(`/exercise/index/${$event.id}`)"
      :id="componentType == 'units' ? data.id : levelId"
      :is="componentType"
    ></component>
  </div>
  <div v-else>
    <pulse-loader
      :loading="true"
      :color="$vuetify.theme.themes.light.primary"
      size="20px"
    />
  </div>
</template>
<script>
//data
import { ageGroup as School } from "@/store/exercise/age-group";
import units from "./units/index.vue";
import lessons from "./lessons/index.vue";
import exercise from "./Exercise/RegularTables.vue";

export default {
  components: {
    units,
    lessons,
    exercise,
  },
  data() {
    return {
      School,
      editData: {},
      levelId: null,
      componentType: "units",
      breadcrumbsItems: [],
    };
  },
  methods: {
    //edit mehods

    //move deep in tree
    nextStep(data, to) {
      this.componentType = to;
      this.levelId = data.id;
      this.breadcrumbsItems.push({ type: to, text: data.name, id: data.id });
    },

    //move by breadcrumbs
    move(data) {
      if (this.componentType == data.type) return;
      let index = this.breadcrumbsItems.indexOf(data);
      if (index == 0) {
        this.componentType = "units";
        this.breadcrumbsItems.splice(1);
        return;
      }
      this.breadcrumbsItems.splice(index + 1);
      this.componentType = data.type;
      this.levelId = data.id;
    },
  },
  computed: {
    //params
    id() {
      return this.$route.params.id;
    },

    //data
    data() {
      return { ...School.tableData.showData };
    },

    // //loaders
    loader() {
      return School.showState.loading;
    },
  },

  async created() {
    await School.show(this.id);
    this.breadcrumbsItems.push({
      text: this.data.name,
      id: this.id,
    });
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 900;
}
h3 {
  font-weight: 900;
  color: gray;
}
h4 {
  font-weight: 800;
}
.v-breadcrumbs .primary--text {
  color: red;
  text-decoration: none;
  font-weight: 800;
  cursor: pointer;
}
.disable {
  color: gray;
  text-decoration: none;
  cursor: default;
}
.arrowUp {
  transform: rotate(180deg);
}
</style>
